export { generatePDFReport } from './pdfGenerator';
export { generateInfographic } from './infographicGenerator';
export { generatePDFReportWithWappen } from './pdfGeneratorClient';
export { generateInfographicWithWappen } from './infographicGeneratorClient';